export function prepareMarkDown( text ) {
	return (text) ? text.replace(/\\n\\n/ig, "\n\n").replace(/\\n/ig, "  \n") : "";
}

export function createAbstract( t ) {
	let output = t.replace(/\r?\n|\r/g,' ').replace(/^(.{75}[^\s]*).*/, "$1") + '…';
	return output;
}

export function formatDate( timestamp ) {
	const d = new Date( parseFloat( timestamp ) * 1000 );
	const gg = "00" + d.getDate();
	const mm = "00" + (d.getMonth()+1);
	return gg.substr(gg.length - 2) + '/' + mm.substr(mm.length - 2);
}

export function formatNumber( n ) {
	n = Math.round( n * 100 ) / 100;
	return new Intl.NumberFormat('it-IT', { style: 'decimal' }).format(n);
}


// WEBPACK FOOTER //
// ./src/Elezioni/helpers/helpers.js